var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.token === ''? 'caption font-weight-bold text-center pa-0':''},[_c('v-container',{staticClass:"py-0"},[_c('div',{class:_vm.token === ''? '':'caption font-weight-bold text-center py-2'},[_vm._v(" 2021 © YEC ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }